<template>
    <div>
        <div class="d-inline-block" style="min-width: 32px;">{{ row.conversation_count }}</div>
        <a :href="row.conversationIndexUrl" v-if="canViewConversationIndex" class="btn btn-primary btn-sm">
            <i class="fas fa-filter"></i>
        </a>
        <a :href="row.conversationListUrl" v-else-if="canViewConversationList" class="btn btn-primary btn-sm">
            <i class="fas fa-filter"></i>
        </a>
    </div>
</template>

<script>
  export default {
    props: [
      'row'
    ],

    computed: {
      /**
       * @returns {boolean}
       */
      canViewConversationIndex() {
        return this.row.canViewConversationIndex;
      },

      /**
       * @returns {boolean}
       */
      canViewConversationList() {
        return this.row.canViewConversationList;
      },
    }
  }
</script>
